import BooleanEditor from './BooleanEditor';
import DateEditor from './DateEditor';
import DateRangeEditor from './DateRangeEditor';
import DropdownEditor from './DropdownEditor';
import EmptyEditor from './EmptyEditor';
import GenericEditor from './GenericEditor';
import InputEditor from './InputEditor';
import ModalEditor from './ModalEditor';
import NameFieldEditor from './NameFieldEditor';
import ProfileDocumentRow from './ProfileDocumentRow';
import ScheduleEditor from './ScheduleEditor';
import StudentVaccineDosesEditor from './StudentVaccineDosesEditor';
import TypeaheadEditor from './TypeaheadEditor';

export default {
  Generic: GenericEditor,
  Input: InputEditor,
  Phone: InputEditor,
  Dropdown: DropdownEditor,
  Date: DateEditor,
  Name: NameFieldEditor,
  Schedule: ScheduleEditor,
  DateRange: DateRangeEditor,
  Empty: EmptyEditor,
  Boolean: BooleanEditor,
  Typeahead: TypeaheadEditor,
  StudentVaccineDoses: StudentVaccineDosesEditor,
  Modal: ModalEditor,
  DocumentRow: ProfileDocumentRow
};
